import { Link } from "react-router-dom";
import { Phone, Mail, ShieldCheck } from "lucide-react";
import { SERVICES } from "../data/services";
import { CITIES, cityPath, servicePath } from "../data/cities";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-slate-950 border-t border-amber-500/15 pt-16 pb-28">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2.5 mb-4">
            <img src="/favicon.png" alt="1st Nations Security logo" className="h-10 w-10" />
            <span className="font-heading font-bold text-white text-lg">1st Nations Security</span>
          </div>
          <p className="text-sm text-slate-400 leading-relaxed mb-4">
            A 100% Indigenous-owned security guard company providing licensed security services across Ontario —
            from Thunder Bay and Northwestern Ontario to the GTA, Ottawa and Windsor.
          </p>
          <div className="space-y-2">
            <a href="tel:+18077700243" data-testid="footer-phone-link" className="flex items-center gap-2 text-amber-400 text-sm font-semibold hover:text-amber-300">
              <Phone className="h-4 w-4" /> +1 807-770-0243
            </a>
            <a href="mailto:admin@1stnation-security.com" data-testid="footer-email-link" className="flex items-center gap-2 text-amber-400 text-sm font-semibold hover:text-amber-300 break-all">
              <Mail className="h-4 w-4 shrink-0" /> admin@1stnation-security.com
            </a>
          </div>
        </div>
        <div>
          <h3 className="text-xs font-semibold uppercase tracking-widest text-amber-500 mb-4">Security Services</h3>
          <ul className="space-y-2">
            {SERVICES.map((s) => (
              <li key={s.slug}>
                <Link to={servicePath(s)} data-testid={`footer-service-link-${s.slug}`} className="text-sm text-slate-400 hover:text-amber-300 transition-colors">
                  {s.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h3 className="text-xs font-semibold uppercase tracking-widest text-amber-500 mb-4">Ontario Service Areas</h3>
          <ul className="grid grid-cols-2 gap-x-3 gap-y-2">
            {CITIES.map((c) => (
              <li key={c.slug}>
                <Link to={cityPath(c)} data-testid={`footer-city-link-${c.slug}`} className="text-sm text-slate-400 hover:text-amber-300 transition-colors">
                  {c.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h3 className="text-xs font-semibold uppercase tracking-widest text-amber-500 mb-4">Company</h3>
          <ul className="space-y-2 mb-6">
            <li><Link to="/" data-testid="footer-home-link" className="text-sm text-slate-400 hover:text-amber-300">Home</Link></li>
            <li><Link to="/security-services" data-testid="footer-services-index-link" className="text-sm text-slate-400 hover:text-amber-300">All Security Services</Link></li>
            <li><Link to="/ontario-service-areas" data-testid="footer-cities-index-link" className="text-sm text-slate-400 hover:text-amber-300">All Service Areas</Link></li>
            <li><Link to="/about-1st-nations-security" data-testid="footer-about-link" className="text-sm text-slate-400 hover:text-amber-300">About Us</Link></li>
            <li><Link to="/security-blog" data-testid="footer-blog-link" className="text-sm text-slate-400 hover:text-amber-300">Security Blog</Link></li>
            <li><Link to="/careers" data-testid="footer-careers-link" className="text-sm text-slate-400 hover:text-amber-300">Careers — Join Our Team</Link></li>
            <li><Link to="/qc" data-testid="footer-quebec-link" className="text-sm text-slate-400 hover:text-amber-300">Services en français (Québec)</Link></li>
            <li><Link to="/contact" data-testid="footer-contact-link" className="text-sm text-slate-400 hover:text-amber-300">Contact</Link></li>
          </ul>
          <div className="flex items-center gap-2 text-sm text-slate-400">
            <ShieldCheck className="h-4 w-4 text-amber-500" /> Licensed security guards serving Ontario
          </div>
        </div>
      </div>
      <div className="mt-12 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-xs text-slate-500">© {new Date().getFullYear()} 1st Nations Security. Security guard services across Ontario, Canada.</p>
        <p className="text-xs text-slate-500">100% Indigenous-Owned · Northwestern Ontario Roots · 24/7 Dispatch</p>
      </div>
    </div>
  </footer>
);
